export const oneTimeProducts = [
  {
    id: 'contracts_level_1',
    value: 'contracts_level_1',
    label: 'shield',
    localeAttributes: { 
      context: 'number',
      number: 1 
    },
      type: 'good'
  },
  {
    id: 'contracts_level_2',
    value: 'contracts_level_2',
    label: 'shield',
    localeAttributes: { 
      context: 'number',
      number: 2
    },
    type: 'good'
  },
  // {
  //   id: 'contracts_level_3',
  //   value: 'contracts_level_3',
  //   label: 'shield',
  //   localeAttributes: { 
  //     context: 'number',
  //     number: 3
  //   },
  //   type: 'good'
  // },
  {
    id: 'templates',
    value: 'templates',
    label: 'customTemplatesPages',
    type: 'good'
  }
];
export const recurringProducts = [
  {
    id: 'storage',
    value: 'storage',
    label: 'storageSubcriptions',
    type: 'service'
  },
  {
    id: 'starter_plan',
    value: 'starter_plan',
    label: 'Planes (Mensual)',
    type: 'service'
  },
];
